// Dashboard archive state, mirrored to the server so it follows the person
// across devices. Every call degrades to "nothing archived" rather than
// failing — a hide button that can break the page it lives on is not worth it.

/** Must match archiveRef in netlify/lib/archive.mts, or nothing matches. */
export const refFor = (stream, id) => stream + ":" + String(id);

export async function loadArchive() {
  try {
    const r = await fetch("/api/archive");
    if (!r.ok) return new Set();
    const d = await r.json();
    return new Set(d.refs || []);
  } catch {
    return new Set();
  }
}

/** Returns true when the server took the change. */
export async function setArchived(ref, archived) {
  try {
    const r = await fetch("/api/archive", {
      method: "POST",
      headers: { "content-type": "application/json" },
      body: JSON.stringify({ ref, archived }),
    });
    return r.ok;
  } catch {
    return false;
  }
}
